import React from 'react';
import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import { RequiresNikeone } from 'nike-ui/src/components/nikeone/RequiresNikeone';
import { ModuleFallback } from '@/common/components/ModuleFallback';

const VirtualGames = Loadable({ loader: imports.virtualGames });

function NikeOneVirtual({ sportSlugPart }) {
    return (
        <RequiresNikeone fallback={<ModuleFallback msg={'nui.module.missing.nikeone'} />}>
            <div className="virtualGames">
                <VirtualGames sportName={sportSlugPart} />
            </div>
        </RequiresNikeone>
    );
}

export default NikeOneVirtual;
